import api from '@disco/api/server'
import {
  PLAYLIST_DELETE_BATCH_SUCCESS,
  PLAYLIST_VERSION_DELETE_SUCCESS,
  SHORTLIST_CLEAR,
  SHORTLIST_DELETE,
  SHORTLIST_NEW,
  SHORTLIST_PLAYLIST_TRACKS_ADD,
  SHORTLIST_SECTION_ADD,
  SHORTLIST_SECTION_REMOVE,
  SHORTLIST_SECTION_UPDATE,
  SHORTLIST_TEMP_ITEM_UPDATE,
  SHORTLIST_UPDATE,
  START_SAVING_STATE,
  TRACK_DELETE_BATCH_SUCCESS,
  TRACK_MERGE_SUCCESS,
} from '@disco/constants/ActionTypes'
import { __REACT_NATIVE__ } from '@disco/constants/environment'
import { STORAGE_DISABLED_NOTIFICATION, STORAGE_FULL_NOTIFICATION } from '@disco/constants/notifications'
import { getShortlists } from '@disco/state-management/selectors/shortlists'
import { getUser } from '@disco/state-management/selectors/user'
import { pushUINotification } from '@disco/utils/notifications'
import { removeBinaryImagesInShortlist } from '@disco/utils/shortlist'
import captureError from '@disco/utils/captureError'
import Storage from 'disco-storage'
import { isQuotaExceededError } from '../utils/local-storage'
import lodashDebounce from 'lodash/debounce'
import bw from 'redux-white-black'

// if Artwork value contains File object, it can't be serilized straght away
// so just use current include value and replace value with empty string
const sanitizeAliases = (aliases: any) => {
  if (!aliases) return aliases
  if (
    aliases.Artwork &&
    aliases.Artwork.value &&
    typeof aliases.Artwork.value === 'object'
  )
    return {
      ...aliases,
      Artwork: {
        include: aliases.Artwork.include,
        value: '',
      },
    }
  return aliases
}

// save only track ids instead of the full track object,
// strip uploading in progress items (tempItems)
function reduceStateSize(shortlists: any[]) {
  let result = shortlists
    .filter((currentItem: any) => !currentItem.hidden)
    .map((currentItem: any) => ({
      ...currentItem,
      items: currentItem.items
        .filter((item: any) => item?.track?.id)
        .map((item: any) => ({
          ...item,
          track: {
            id: item.track.id,
          },
        })),
      tempItems: [],
      playlist_aliases: sanitizeAliases(currentItem.playlist_aliases),
    }))
  result = result.map((shortlist: any) =>
    removeBinaryImagesInShortlist(shortlist),
  )
  return result
}

function saveToStorage(action: any, state: any) {
  const reducerState = state.getState()
  const { user } = reducerState

  if (user.autoSave && user.loggedIn) {
    {
      const shortlistState = reduceStateSize(getShortlists(reducerState))
      const storageKey = __REACT_NATIVE__
        ? `disco-${user.business.id}-${user.id}`
        : `disco-${user.id}`
      Storage.set(storageKey, shortlistState, {
        onError: (error: any) => {
          pushUINotification(isQuotaExceededError(error) ? STORAGE_FULL_NOTIFICATION : STORAGE_DISABLED_NOTIFICATION)
          captureError(error)
        },
      })
    }
  }
}

const syncStateWithServer = async (action: any, state: any) => {
  const reducerState = state.getState()
  if (!getUser(reducerState).loggedIn) return
  const shortlistState = reduceStateSize(getShortlists(reducerState))

  try {
    api.syncShortlistsState(shortlistState)
  } catch (e) {}
}

const saveState = lodashDebounce(
  (action, state) => {
    if (
      action.type === SHORTLIST_TEMP_ITEM_UPDATE &&
      action.finalUpdate !== true
    ) {
      return
    }

    saveToStorage(action, state)
  },
  300,
  {
    leading: false,
    trailing: true,
  },
)
const syncState = lodashDebounce(
  (action, state) => {
    syncStateWithServer(action, state)
  },
  10 * 1000,
  {
    leading: false,
    trailing: true,
  },
)

const processState = (action: any, state: any) => {
  if (getUser(state.getState()).loggedIn) {
    saveState(action, state)
    syncState(action, state)
  }
} // here should be list of actions that affect shortlist contents
// excluding UI state changes or temporary uploading items that are not
// included into saved local state object

export default bw.whitelist(
  [
    PLAYLIST_DELETE_BATCH_SUCCESS,
    PLAYLIST_VERSION_DELETE_SUCCESS,
    SHORTLIST_CLEAR,
    SHORTLIST_DELETE,
    SHORTLIST_NEW,
    SHORTLIST_PLAYLIST_TRACKS_ADD,
    SHORTLIST_SECTION_ADD,
    SHORTLIST_SECTION_REMOVE,
    SHORTLIST_SECTION_UPDATE,
    SHORTLIST_TEMP_ITEM_UPDATE,
    SHORTLIST_UPDATE,
    START_SAVING_STATE,
    TRACK_DELETE_BATCH_SUCCESS,
    TRACK_MERGE_SUCCESS,
  ],
  processState,
)
